import { mergeRefs } from "@suse-o11y/merge-refs";
import { Slot, type Slottable } from "@suse-o11y/slot";
import React from "react";

import { TooltipCollisionBoundaryProvider, useTooltipCollisionBoundaries } from "./context";

export interface CollisionBoundaryProps extends React.ComponentPropsWithoutRef<"div">, Slottable {}

export const CollisionBoundary = React.forwardRef<React.ComponentRef<"div">, CollisionBoundaryProps>(
	({ asChild, ...props }, ref) => {
		const [element, setElement] = React.useState<null | Element>(null);
		const outerCollisionBoundaries = useTooltipCollisionBoundaries();

		const Node = asChild ? Slot : "div";

		const collisionBoundaries = React.useMemo(
			() => (element == null ? outerCollisionBoundaries : [element, ...outerCollisionBoundaries]),
			[element, outerCollisionBoundaries],
		);

		return (
			<TooltipCollisionBoundaryProvider value={collisionBoundaries}>
				<Node {...props} ref={mergeRefs([ref, setElement])} />
			</TooltipCollisionBoundaryProvider>
		);
	},
);

CollisionBoundary.displayName = "Tooltip.CollisionBoundary";
